import { Routes } from '@angular/router';

import { WelcomeComponent } from './../welcome/welcome.component';
import { SaisieComponent } from './saisie/saisie.component';
import { AdministrationComponent } from './administration/administration.component';
import { ExtractionComponent } from './extraction/extraction.component';
import { TopicComponent } from './topic/topic.component';
import { AuthGuardService } from './auth/auth-guard.service';
// CAP-40007 TCL-22 - RBAC route protection: guard hidden pages by functional area.
import { RoleGuardService } from './auth/role-guard.service';
import { TclArea } from './auth/roles.constants';

// CAP-40007 TCL-2727 - Legacy /login page removed; users authenticate directly on PingFederate.
// The shell route is guarded, which triggers the PingFederate login flow when unauthenticated.
// CAP-40007 TCL-22 - Each child route also declares its RBAC area and is protected by RoleGuardService
// so users cannot reach a hidden page directly via URL.
export const appRoutes: Routes = [
    {path: '',  redirectTo: '/tcl', pathMatch: 'full' },
    {
        path: 'tcl',
        component: WelcomeComponent,
        canActivate: [AuthGuardService],
        children: [
            {path: 'saisie',  component: SaisieComponent, canActivate:[AuthGuardService, RoleGuardService], data: { area: TclArea.SAISIE }},
            {path: 'administration',  component: AdministrationComponent, canActivate:[AuthGuardService, RoleGuardService], data: { area: TclArea.ADMIN }},
            {path: 'extraction',  component: ExtractionComponent, canActivate:[AuthGuardService, RoleGuardService], data: { area: TclArea.EXTRACTION }},
            {path: 'topic/:stringToSubmit',  component: TopicComponent, canActivate:[AuthGuardService, RoleGuardService], data: { area: TclArea.SAISIE }},
        ]
    },
    {path: '**',  redirectTo: '/tcl', pathMatch: 'full' },
];
